export const environment = {
    production: false
};

export const projectConfig = {
    apiURL: 'https://ykz2dsec13.execute-api.eu-central-1.amazonaws.com/backend/api/v1/',
    chatPromptURL: 'https://ykz2dsec13.execute-api.eu-central-1.amazonaws.com/chatbot/api/v1/',
    bucketName: 's-gameplan-backens-docs-s3'
};


export const loginConfig = {
    apiURL: 'https://ykz2dsec13.execute-api.eu-central-1.amazonaws.com/backend/api/v1/auth/login',
    apiURL_SSO:'https://ykz2dsec13.execute-api.eu-central-1.amazonaws.com/backend/api/v1/sso-auth/token_authenticate',
    sso_redirectUrl:'https://gameplan.sbx.uptimize.merckgroup.com',
    Client_ID:"",
    Tenant_ID:"",
}



